import { useTranslation } from 'react-i18next';
import { Modal, ModalActions, ModalContent, ModalTitleInfo, Button } from '@c2fo/liquidity';
import mobilePhoneError from '@/enterprise/assets/mobilephoneerror.svg?url';

const OfferSubmitErrorModal = ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (open: boolean) => void }) => {
  const { t } = useTranslation();
  return (
    <Modal open={isOpen} onClose={() => setIsOpen(false)} size="sm">
      <ModalTitleInfo>{t('builder.errorModal.title')}</ModalTitleInfo>
      <ModalContent center>
        <img alt={t('builder.errorModal.title')} src={mobilePhoneError} />
        <p className="max-w-xs text-center text-base">{t('builder.errorModal.description')}</p>
      </ModalContent>
      <ModalActions>
        <Button className="w-full sm:w-fit" variant="secondary" onClick={() => setIsOpen(false)}>
          {t('core.close')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default OfferSubmitErrorModal;
